export default __webpack_public_path__ + "static/media/srch-off-nav.0a344c9f.svg";